/*
 * Copyright (c) 2024 Amazon.com, Inc. All Rights Reserved.
 */

export function isJSONResponse(response: string): boolean {
  try {
    return (JSON.parse(response) && !!response);
  } catch (e) {
    return false;
  }
}